import { createFileRoute } from '@tanstack/react-router'
import { OAuthConsent } from '../../../features/oauth/components/oauth-consent'

// Under /app like the login page: the marketing site's host only forwards /app, /admin, /s and a few asset
// paths to the studio, so a root-level /oauth path would answer with its 404. The studio's own sign-in and
// onboarding screens also handle anyone who arrives here not signed in.
export const Route = createFileRoute('/app/oauth/consent')({
  component: OAuthConsent,
})
